import { render, staticRenderFns } from "./createRole.vue?vue&type=template&id=1840ff2f&scoped=true"
import script from "./createRole.vue?vue&type=script&lang=js"
export * from "./createRole.vue?vue&type=script&lang=js"
import style0 from "./createRole.vue?vue&type=style&index=0&id=1840ff2f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840ff2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1840ff2f')) {
      api.createRecord('1840ff2f', component.options)
    } else {
      api.reload('1840ff2f', component.options)
    }
    module.hot.accept("./createRole.vue?vue&type=template&id=1840ff2f&scoped=true", function () {
      api.rerender('1840ff2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/baseInfo/staffManage/roleMgr/createRole.vue"
export default component.exports